@switch (type()) {
@case ("default") {
<button type="button" class="cb-button" [ngClass]="[
        'cb-size-' + size(),
        'cb-hierarchy-' + hierarchy(),
        'cb-color-' + currColor(),
        'cb-status-' + status(),
        'cb-alignment-' + textAlignment(),
      ]" [class.cb-disabled]="disabled()" (click)="onClick($event)">
  <ng-template *ngTemplateOutlet="StandardButtonContent"></ng-template>
</button>
}
@case ("submit") {
<button (click)="clickSubmit($event)" class="cb-button" [ngClass]="[
        'cb-size-' + size(),
        'cb-hierarchy-' + hierarchy(),
        'cb-color-' + currColor(),
        'cb-status-' + status(),
        'cb-alignment-' + textAlignment(),
      ]" [class.cb-disabled]="disabled()">
  @switch (status()) {
  @case ("idle") {
  <ng-template *ngTemplateOutlet="StandardButtonContent"></ng-template>
  }
  @case ("loading") {
  <svg class="cb-loading-icon" width="16" height="16" viewBox="0 0 52 52" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M49.6908 26C50.9662 26 52.0106 27.0359 51.8975 28.3062C51.5121 32.6348 50.0462 36.8111 47.6182 40.4448C44.7613 44.7205 40.7006 48.053 35.9498 50.0209C31.1989 51.9887 25.9712 52.5036 20.9277 51.5004C15.8841 50.4972 11.2514 48.0209 7.61522 44.3848C3.97906 40.7486 1.5028 36.1159 0.499583 31.0723C-0.503633 26.0288 0.0112537 20.8011 1.97913 16.0502C3.94701 11.2994 7.2795 7.23871 11.5552 4.38179C15.1889 1.9538 19.3652 0.487905 23.6938 0.102464C24.9641 -0.0106481 26 1.03384 26 2.30916V2.30916C26 3.58447 24.9632 4.60541 23.6953 4.74287C20.2815 5.113 16.9949 6.30149 14.121 8.22178C10.6048 10.5712 7.86423 13.9106 6.2459 17.8176C4.62757 21.7246 4.20414 26.0237 5.02916 30.1714C5.85417 34.319 7.89058 38.1289 10.8809 41.1191C13.8711 44.1094 17.681 46.1458 21.8286 46.9708C25.9763 47.7959 30.2754 47.3724 34.1824 45.7541C38.0894 44.1358 41.4288 41.3952 43.7782 37.879C45.6985 35.0051 46.887 31.7185 47.2571 28.3047C47.3946 27.0368 48.4155 26 49.6908 26V26Z"
      fill="currentColor" />
  </svg>
  }
  @case ("success") {
  <cb-icon name="cb cb-base-bold-checkmark-circle"></cb-icon>
  }
  @case ("error") {
  <cb-icon class="cb-error-icon" name="cb cb-base-outline-close"></cb-icon>
  }
  }
</button>
}
@case ("iconOnly") {
<div class="cb-icon-button" (click)="onClick($event)">
  <button type="button" class="cb-icon-button cb-icon-b" [ngClass]="[
          'cb-size-' + size(),
          'cb-hierarchy-' + hierarchy(),
          'cb-color-' + currColor(),
          'cb-status-' + status(),
          'cb-alignment-' + textAlignment(),
          buttonType(),
        ]" [class.cb-disabled]="disabled()" [cbTooltip]="label() ?? ''">
    @if (!loading()) {
    <cb-icon [name]="icon() ?? ''"></cb-icon>
    } @else {
    <svg class="cb-loading-icon" width="16" height="16" viewBox="0 0 52 52" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M49.6908 26C50.9662 26 52.0106 27.0359 51.8975 28.3062C51.5121 32.6348 50.0462 36.8111 47.6182 40.4448C44.7613 44.7205 40.7006 48.053 35.9498 50.0209C31.1989 51.9887 25.9712 52.5036 20.9277 51.5004C15.8841 50.4972 11.2514 48.0209 7.61522 44.3848C3.97906 40.7486 1.5028 36.1159 0.499583 31.0723C-0.503633 26.0288 0.0112537 20.8011 1.97913 16.0502C3.94701 11.2994 7.2795 7.23871 11.5552 4.38179C15.1889 1.9538 19.3652 0.487905 23.6938 0.102464C24.9641 -0.0106481 26 1.03384 26 2.30916V2.30916C26 3.58447 24.9632 4.60541 23.6953 4.74287C20.2815 5.113 16.9949 6.30149 14.121 8.22178C10.6048 10.5712 7.86423 13.9106 6.2459 17.8176C4.62757 21.7246 4.20414 26.0237 5.02916 30.1714C5.85417 34.319 7.89058 38.1289 10.8809 41.1191C13.8711 44.1094 17.681 46.1458 21.8286 46.9708C25.9763 47.7959 30.2754 47.3724 34.1824 45.7541C38.0894 44.1358 41.4288 41.3952 43.7782 37.879C45.6985 35.0051 46.887 31.7185 47.2571 28.3047C47.3946 27.0368 48.4155 26 49.6908 26V26Z"
        fill="currentColor" />
    </svg>
    }
  </button>

  <ng-content></ng-content>
</div>
}
}

<ng-template #StandardButtonContent>
  @if (iconPosition() == "left") {
  @if (icon()) {
  <cb-icon [name]="icon()!"></cb-icon>
  }
  }
  @if (label() && label()!.length > 0) {
  <p>{{ label() }}</p>
  } @else {
  <ng-content></ng-content>
  }
  @if (iconPosition() == "right") {
  @if (icon()) {
  <cb-icon [name]="icon()!"></cb-icon>
  }
  }
</ng-template>